/* EDM : barre de progression et flèches au survol pour le carrousel (thème Warehouse, Flickity).
   Validé par Jeremy le 14/10/2026. Pilote le carrousel par ses points natifs (masqués en CSS).
   Le défilement auto du thème reste maître ; ce script ne prend le relais que s'il s'arrête
   (Flickity coupe l'autoplay dès qu'on clique ou qu'on fait glisser). */
(function () {
  var CSS =
    '.edm-wrap{position:relative}' +
    '.edm-bar{display:flex;gap:4px;height:2px;background:#fff}' +
    '.edm-seg{flex:1;height:2px;background:#e6e6e6;cursor:pointer;position:relative;overflow:hidden;border:0;padding:0;margin:0;border-radius:0}' +
    '.edm-seg:hover{background:#d4d4d4}' +
    '.edm-seg i{position:absolute;top:0;left:0;bottom:0;width:0;background:#8a8a8a;display:block}' +
    '.edm-arrow{position:absolute;top:50%;transform:translateY(-50%);width:44px;height:44px;border-radius:50%;border:0;padding:0;background:rgba(255,255,255,.75);color:#1a4f9c;font-size:22px;line-height:44px;text-align:center;cursor:pointer;opacity:0;transition:opacity .25s;z-index:5;box-shadow:0 2px 8px rgba(0,0,0,.12)}' +
    '.edm-wrap:hover .edm-arrow,.edm-arrow:focus-visible{opacity:1}' +
    '.edm-prev{left:16px}.edm-next{right:16px}' +
    '@media (hover:none){.edm-arrow{display:none}}';

  function init(s) {
    if (s.dataset.edmNav) return;
    var slides = [].slice.call(s.querySelectorAll('.slideshow__slide'));
    var N = slides.length;
    if (N < 2 || !s.querySelector('.flickity-page-dots')) return;
    s.dataset.edmNav = '1';

    var DUR = 5000;
    try {
      var cfg = JSON.parse(s.closest('[data-section-settings]').getAttribute('data-section-settings'));
      if (cfg.cycleSpeed) DUR = cfg.cycleSpeed;
    } catch (e) {}

    var cur = function () { for (var i = 0; i < N; i++) if (slides[i].classList.contains('is-selected')) return i; return 0; };
    var go = function (i) { var d = s.querySelectorAll('.flickity-page-dots .dot'); if (d[i]) d[i].click(); };

    var wrap = s.parentElement;
    wrap.classList.add('edm-wrap');
    var bar = document.createElement('div');
    bar.className = 'edm-bar';
    for (var i = 0; i < N; i++) (function (i) {
      var b = document.createElement('button');
      b.type = 'button'; b.className = 'edm-seg';
      b.setAttribute('aria-label', 'Afficher la diapositive ' + (i + 1) + ' sur ' + N);
      b.appendChild(document.createElement('i'));
      b.addEventListener('click', function () { go(i); });
      bar.appendChild(b);
    })(i);
    s.parentNode.insertBefore(bar, s.nextSibling);

    function arrow(cls, txt, label, delta) {
      var b = document.createElement('button');
      b.type = 'button'; b.className = 'edm-arrow ' + cls; b.textContent = txt;
      b.setAttribute('aria-label', label);
      b.addEventListener('click', function () { go((cur() + delta + N) % N); });
      wrap.appendChild(b);
    }
    arrow('edm-prev', '‹', 'Diapositive précédente', -1);
    arrow('edm-next', '›', 'Diapositive suivante', 1);

    var t0 = performance.now(), last = cur(), paused = false, pausedAt = 0, relais = false;
    var restart = function () { t0 = performance.now(); };
    wrap.addEventListener('mouseenter', function () { paused = true; pausedAt = performance.now(); });
    wrap.addEventListener('mouseleave', function () { paused = false; restart(); });
    document.addEventListener('visibilitychange', restart);

    var segs = bar.children;
    (function loop() {
      var c = cur();
      if (c !== last) { last = c; restart(); }
      var el = (paused ? pausedAt : performance.now()) - t0;
      var p = Math.min(el / DUR, 1);
      for (var k = 0; k < N; k++) segs[k].firstChild.style.width = (k === c ? p * 100 : k < c ? 100 : 0) + '%';
      // relais : l'autoplay du thème n'a pas avancé 1,2 s après l'échéance ; ensuite, cadence normale
      if (!paused && el > DUR + (relais ? 0 : 1200)) { relais = true; go((c + 1) % N); restart(); }
      requestAnimationFrame(loop);
    })();
  }

  function start() {
    var st = document.createElement('style');
    st.textContent = CSS;
    document.head.appendChild(st);
    var tries = 0;
    (function wait() {
      var list = document.querySelectorAll('.slideshow.flickity-enabled');
      for (var i = 0; i < list.length; i++) init(list[i]);
      if (++tries < 40) setTimeout(wait, 250);
    })();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
